module.exports = __webpack_public_path__ + "images/5de978d5b977714e7b4614888906cd38.png";